import { graphql } from 'gatsby';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from '../../components/common/layout';
import { SEO } from '../../components/common/seo';
import { BackLink } from './components/back-link';
import { ContentPost } from './components/content-post';
import { HeroPost } from './components/hero-post';
import { RelatedPosts } from './components/related-posts';
import type { PostPageProps } from './types';

const PostPage: FC<PostPageProps> = ({ data, pageContext, ...props }) => {
    const { strapiArticle: post } = data;
    const { t } = useTranslation();

    const translatedSlugs = post.localizations.data.map(({ attributes }) => attributes);

    return (
        <Layout {...props} postTranslatedSlugs={translatedSlugs}>
            <SEO title={`${post.title} - ${t('general.seo.learn_trade', 'Learn Trade')}`} />
            <section className="mt-16">
                <HeroPost post={post} />
                <div className="bg-sliderSection">
                    <ContentPost postId={post.id} content={post.content.data.content} />
                    <RelatedPosts relatedArticles={data.relatedArticles.nodes} />
                </div>
                <BackLink lang={pageContext.lang} />
            </section>
        </Layout>
    );
};

export const query = graphql`
    query ($slug: String!, $relatedPosts: [Int], $lang: String) {
        strapiArticle(slug: { eq: $slug }, locale: { eq: $lang }) {
            id: strapi_id
            title
            publishedAt
            updatedAt
            content {
                data {
                    content
                }
            }
            isActive
            locale
            authors {
                id
                first_name
                last_name
                createdAt
                updatedAt
            }
            slug
            next
            prev
            header_image {
                CloudinaryImageFromStrapi(quality: 90)
            }
            localizations {
                data {
                    attributes {
                        slug
                        locale
                    }
                }
            }
        }
        relatedArticles: allStrapiArticle(
            filter: { strapi_id: { in: $relatedPosts }, isActive: { eq: true } }
        ) {
            nodes {
                id: strapi_id
                title
                publishedAt
                isActive
                content {
                    data {
                        content
                    }
                }
                locale
                authors {
                    id
                    first_name
                    last_name
                    createdAt
                    updatedAt
                }
                slug
                slide_image: header_image {
                    CloudinaryImageFromStrapi(quality: 90)
                }
            }
        }
    }
`;

export default PostPage;
